export default "__VITE_ASSET__DhmyDRhW__"